import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Redirect } from "./components/Redirect";
import { Home } from "./components/Home";
import ListDecisions from "./components/ListDecisions";
import {ListDraws} from "./components/ListDraws";
import {EditDraw} from "./components/EditDraw";
import ListItems from "./components/ListItems";
import {EditItem} from "./components/EditItem";
import ListWants from "./components/ListWants";
import {EditWant} from "./components/EditWant";
import {QuickDraw} from "./components/QuickChoice";
import {EditDecision} from "./components/EditDecision";
import {Car} from "./components/Car"
import {Soda} from "./components/Soda"
import ListTimeLogs from "./components/ListTimeLogs";
import {EditTimeLog} from "./components/EditTimeLog";
import {ListAocChallenges} from "./components/ListAocChallenges";
import LoginPage from "./components/Login";
import {EditSwimlane} from "./components/EditSwimlane";
const AppRoutes = [
  {
    index: true,
    element: <Redirect />
  },
  {
    path: '/counter',
    element: <Counter />
  },
  {
    path: '/fetch-data',
    element: <FetchData />
  },
  {
    path: "/decisions",
    element: <ListDecisions />
  },
  {
    path: "/decisions/:decisionId/edit",
    element: <EditDecision />
  },
  {
    path: "/decisions/:decisionId",
    element: <ListDraws />
  },
  {
    path: "/draws/:drawId/edit",
    element: <EditDraw />
  },
  {
    path: "/items",
    element: <ListItems />
  },
  {
    path: "/items/:itemId/edit",
    element: <EditItem />
  },
  {
    path: "/wants",
    element: <ListWants />
  },
  {
    path: "/swimlanes/:swimlaneId/edit",
    element: <EditSwimlane />
  },
  {
    path: "/wants/:wantId/edit",
    element: <EditWant />
  },
  {
    path: "/quick",
    element: <QuickDraw />
  },
  {
    path: "/car",
    element: <Car />
  },
  {
    path: "/soda",
    element: <Soda />
  },
  {
    path: "/aoc",
    element: <ListAocChallenges />
  },
  {
    path: "/timelogs/:workDate",
    element: <ListTimeLogs />
  },
  {
    path: "/timelogs",
    element: <ListTimeLogs />
  },
  {
    path: "/timelogs/edit/:timeLogId",
    element: <EditTimeLog />
  },
  {
    path: "/login",
    element: <LoginPage />,
    public: true
  }
];

export default AppRoutes;
